import { useState } from "react"

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false)

  const navLinks = [
    { label: "Home", href: "/" },
    { label: "Rooms", href: "#rooms" },
    { label: "Why Choose Us", href: "#why-choose-us" },
    { label: "Testimonials", href: "#testimonials" },
    { label: "Contact", href: "#contact" },
  ]

  return (
    <nav className="sticky top-0 z-50 w-full bg-slate-900 text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
        <div className="flex h-16 md:h-20 items-center justify-between gap-4">
          {/* LOGO */}
          <a href="/" className="flex items-center">
            <img
              className="h-10 sm:h-12 md:h-12 object-contain"
              src="/images/icons/STAY-SUITE_LOGO-V1.webp"
              alt="Stay Suite Logo"
            />
          </a>

          {/* DESKTOP CTA */}
          <button
            className="hidden lg:inline-flex bg-orange-500 px-5 py-2.5 rounded-md 
            text-sm font-semibold hover:bg-orange-600 transition shadow-lg shadow-orange-500/20"
          >
            Inquire Now
          </button>

          {/* MOBILE MENU BUTTON */}
          <button
            type="button"
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden inline-flex h-10 w-10 items-center justify-center rounded-md 
            border border-slate-700 text-slate-200 hover:border-orange-500 hover:text-orange-500 transition"
            aria-label="Toggle navigation menu"
          >
            {isOpen ? (
              <span className="text-2xl leading-none">×</span>
            ) : (
              <span className="text-2xl leading-none">☰</span>
            )}
          </button>
        </div>

        {/* MOBILE NAVIGATION */}
        {isOpen && (
          <div className="lg:hidden border-t border-slate-700 py-4">
            <div className="flex flex-col gap-2">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  onClick={() => setIsOpen(false)}
                  className="rounded-md px-4 py-3 text-sm font-medium text-slate-300 
                  hover:bg-slate-800 hover:text-orange-500 transition"
                >
                  {link.label}
                </a>
              ))}

              <button
                onClick={() => setIsOpen(false)}
                className="mt-3 bg-orange-500 px-5 py-3 rounded-md 
                text-sm font-semibold hover:bg-orange-600 transition"
              >
                Inquire Now
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  )
}
